import { render, staticRenderFns } from "./MailingView.vue?vue&type=template&id=9f2ceb92&scoped=true"
import script from "./MailingView.vue?vue&type=script&lang=js"
export * from "./MailingView.vue?vue&type=script&lang=js"
import style0 from "./MailingView.vue?vue&type=style&index=0&id=9f2ceb92&prod&lang=css"
import style1 from "./MailingView.vue?vue&type=style&index=1&id=9f2ceb92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2ceb92",
  null
  
)

export default component.exports